var map = {
	"./bac.png": "dded",
	"./bacground.png": "e571",
	"./back.png": "90b3",
	"./close.png": "be11",
	"./cry.png": "f81f",
	"./fail-bg.png": "46f7",
	"./fail.png": "e266",
	"./four/man/1.png": "07dc",
	"./four/man/2.png": "5557",
	"./four/man/3.png": "add6",
	"./four/man/4.png": "64a2",
	"./four/woman/1.png": "464b",
	"./four/woman/2.png": "efea",
	"./four/woman/3.png": "5a8b",
	"./four/woman/4.png": "3d67",
	"./game-bac.png": "e576",
	"./game-box.png": "1c32",
	"./gir-info.png": "5707",
	"./girl.png": "01d7",
	"./guanka.png": "3668",
	"./info.png": "2425",
	"./kong-star.png": "9948",
	"./kuang.png": "b065",
	"./kuang1.png": "02ea",
	"./man-star.png": "6b59",
	"./no.png": "8c46",
	"./one/man/1.png": "43ed",
	"./one/man/2.png": "82e8",
	"./one/man/3.png": "16e1",
	"./one/man/4.png": "727f",
	"./one/woman/1.png": "106f",
	"./one/woman/2.png": "d37d",
	"./one/woman/3.png": "e489",
	"./one/woman/4.png": "9bc0",
	"./pause-bg.png": "ef5c",
	"./pause.png": "3d70",
	"./pic.png": "10e0",
	"./pop-kid.png": "867f",
	"./precess.png": "7469",
	"./right.png": "fe2c",
	"./star.png": "a477",
	"./start-info.png": "7af8",
	"./start.png": "b730",
	"./success-bg.png": "6154",
	"./three/man/1.png": "e295",
	"./three/man/2.png": "f115",
	"./three/man/3.png": "5152",
	"./three/man/4.png": "f6f6",
	"./three/woman/1.png": "056d",
	"./three/woman/2.png": "1171",
	"./three/woman/3.png": "ec90",
	"./three/woman/4.png": "ceca",
	"./times.png": "e8c1",
	"./tui.png": "e497",
	"./two/man/1.png": "d5d1",
	"./two/man/2.png": "e83f",
	"./two/man/3.png": "42d0",
	"./two/man/4.png": "30ce",
	"./two/woman/1.png": "b483",
	"./two/woman/2.png": "7e73",
	"./two/woman/3.png": "297d",
	"./two/woman/4.png": "ed2c",
	"./yes.png": "5015"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2fd2";